import React, { Component } from "react";
import Rodal from "rodal";

import LeaveCarryProcessStartConfirmDialog from "./LeaveCarryProcessStartConfirmDialog";

export default class LeaveCarryProcessStartButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isDialogVisible: false,
    };
  }

  showDialog = () => {
    this.setState({
      isDialogVisible: true,
    });
  };

  hideDialog = () => {
    this.setState({
      isDialogVisible: false,
    });
  };

  onClickConfirm = () => {
    this.hideDialog();
    this.props.startLeaveCarryProcess();
  };

  render() {
    return (
      <div className="col-lg-4" style={{ marginTop: "20px" }}>
        <Rodal
          width={800}
          height={613}
          visible={this.state.isDialogVisible}
          onClose={this.hideDialog}
        >
          <LeaveCarryProcessStartConfirmDialog
            currentLeaveCarryYears={this.props.currentLeaveCarryYears}
            hideDialog={this.hideDialog}
            onClickConfirm={this.onClickConfirm}
          />
        </Rodal>
        <div
          style={{
            display: "flex",
            justifyContent: "center",
          }}
        >
          <button
            type="button"
            className="btn btn-primary"
            onClick={this.showDialog}
            disabled={this.props.disabled}
          >
            Start the Leave Carrying Process
          </button>
        </div>
        {this.props.alreadyCalculated &&
          !this.props.isLeaveCarryStart &&
          this.props.hasFetchedData && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                marginTop: "5px",
              }}
            >
              Calculation Done for This Fiscal Year
            </div>
          )}
        {this.props.isLeaveCarryStart && this.props.hasFetchedData && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: "5px",
            }}
          >
            Earned Leave Carry-Over in Progress
          </div>
        )}
      </div>
    );
  }
}
